import { Button } from '@/components/ui/button';
import {
  DATE_FORMAT,
  DATE_FORMAT_NO_YEAR,
} from '@/components/ui/date-selector/date-selector-popover';
import { PDKDeliveryDateIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';

const DateBadge = ({
  date,
  hideIcon = false,
  hideYear = false,
  dateClassName,
  placeholder = 'Add date',
  icon,
}: {
  date: string;
  hideIcon?: boolean;
  hideYear?: boolean;
  dateClassName?: string;
  placeholder?: React.ReactNode;
  icon?: React.ReactNode;
}) => {
  return (
    <Button variant="ghost" className="p-1 h-fit">
      {!hideIcon && (
        <div className={cn('h-3.5 w-3.5 cursor-pointer', {})}>
          {icon || (
            <PDKDeliveryDateIcon
              className={cn('h-3.5 w-3.5 cursor-pointer', {})}
            />
          )}
        </div>
      )}
      <p className={cn(' rounded text-xs  text-gray-600', dateClassName)}>
        {dayjs(date).isValid()
          ? dayjs(date).format(hideYear ? DATE_FORMAT_NO_YEAR : DATE_FORMAT)
          : placeholder}
      </p>
    </Button>
  );
};

export default DateBadge;
